module.exports = __webpack_public_path__ + "img/35.eda897ae.jpg";